<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-4">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
      >{{ alert.message }}</ngb-alert
    >

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">Set your new password</h1>
      </div>
    </div>

    <div class="row d-flex justify-content-center pb-5">
      <div class="col-md-5  mb-3">
        <form
          #setPasswordForm="ngForm"
          (ngSubmit)="setPassword()"
          [appMatchingFields]="['password', 'passwordConfirm']"
          novalidate
        >
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div class="mb-3">
              <div>
                <label class="form-label" for="password"> Password </label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    #password="ngModel"
                    [type]="hidePassword ? 'password' : 'text'"
                    [class.is-invalid]="password.touched && !password.valid"
                    id="password"
                    name="password"
                    [(ngModel)]="model.password"
                    placeholder="Password"
                    required
                    passwordStrength
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidePassword"
                  >
                    <mat-icon>{{
                      hidePassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                  <mat-error
                    *ngIf="
                      (password.errors && password.errors.minlength) ||
                      (password.errors && password.errors.required)
                    "
                  >
                    {{
                      password.errors && password.errors.minlength
                        ? errorStrings.passwordTooShort
                        : errorStrings.required
                    }}
                  </mat-error>
                </mat-form-field>
                <app-zxcvbn-password-strength [password]="model.password" [control]="password" />
              </div>
            </div>

            <div class="mb-3">
              <div>
                <label class="form-label" for="passwordConfirm"> Confirm password </label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    #passwordConfirm="ngModel"
                    [type]="hideConfirmPassword ? 'password' : 'text'"
                    [class.is-invalid]="
                      passwordConfirm.touched && !passwordConfirm.valid
                    "
                    id="passwordConfirm"
                    minlength="8"
                    name="passwordConfirm"
                    ngModel=""
                    placeholder="Confirm password"
                    required
                  />
                  <button
                    mat-icon-button
                    type="button"
                    matSuffix
                    (click)="hideConfirmPassword = !hideConfirmPassword"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hideConfirmPassword"
                  >
                    <mat-icon>{{
                      hideConfirmPassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                  <mat-error
                    *ngIf="
                      (passwordConfirm.errors &&
                        passwordConfirm.errors.required) ||
                      (passwordConfirm.errors &&
                        passwordConfirm.errors.minlength) ||
                      (passwordConfirm.errors &&
                        passwordConfirm.errors.matchingFields)
                    "
                  >
                    {{
                      passwordConfirm.errors && passwordConfirm.errors.required
                        ? errorStrings.required
                        : passwordConfirm.errors &&
                          passwordConfirm.errors.minlength
                        ? errorStrings.passwordTooShort
                        : errorStrings.passwordMismatch
                    }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-success text-white btn-lg w-100 mt-5"
            [disabled]="!setPasswordForm.valid || loading"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            {{ loading ? "Updating..." : "Update password" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
